// *"for each of wetness, productivity, and fertility: the raw 'percentile' layer should spiral on.
import { flipDelayFraction, type AnimCell } from "./mapSoilAnimation";

export const BEHAVIOR_AXES = ["moisture", "productivity", "fertility"] as const;
export type BehaviorAxis = (typeof BEHAVIOR_AXES)[number];

/* * Six beats inside the five seconds — spiral on, settle to deciles, three times over. */
export const BEATS = BEHAVIOR_AXES.length * 2;

/*
 *
 * THE WHOLE SEQUENCE FITS INSIDE `spanMs`, because the zones and the PRICE arrive at five seconds
 * whatever the pixels are doing — specified that separately, for every preset.
 */
export function beatAt(
  t: number,
  spanMs: number,
): { axis: BehaviorAxis; showDecile: boolean; within: number } {
  const per = spanMs / BEATS;
  const i = Math.min(BEATS - 1, Math.max(0, Math.floor(t / per)));
  return {
    axis: BEHAVIOR_AXES[Math.floor(i / 2)]!,
    showDecile: i % 2 === 1,
    within: Math.min(1, (t - i * per) / per),
  };
}

/*
 *
 * A percentile of exactly 100 belongs in the tenth decile, not an eleventh the same clamp both
 * existing implementations make, and the reason this is a shared edge rather than three independent
 * `Math.
 */
export function decileOf(pct: number): number {
  return Math.max(0, Math.min(9, Math.floor(pct / 10)));
}

/* * Has this cell's tile flipped yet, within a beat that runs 0→1? Centre first, arm rotating as it grows. */
export function tileIn(cell: AnimCell, within: number): boolean {
  return within >= flipDelayFraction(cell);
}

export function decileColor(
  stops: string[] | null | undefined,
  decile: number,
): string | null {
  if (!stops || !stops.length) return null;
  const at = Math.round((decile / 9) * (stops.length - 1));
  return stops[Math.min(stops.length - 1, Math.max(0, at))] ?? null;
}
